const readLocalObject = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || {};
  } catch (error) {
    return {};
  }
};

const requireValidationPermission = (to, from, next) => {
  const config = readLocalObject("config");
  const groupsConfig = readLocalObject("groupsConfig");

  if (
    config.analiseRelatoriosIaValidacao === true &&
    groupsConfig.analiseRelatoriosIaValidacao === true
  ) {
    next();
    return;
  }

  next("/cidade");
};

export const routes = [
  {
    path: "/analise-relatorios-ia",
    component: () =>
      import(
        /* webpackChunkName: "analise-relatorios-ia" */ "./components/Painel.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: requireValidationPermission,
  },
  {
    path: "/analise-relatorios-ia/validacao",
    name: "analise-relatorios-ia.validacao",
    component: () =>
      import(
        /* webpackChunkName: "analise-relatorios-ia" */ "./components/Painel.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: requireValidationPermission,
  },
  {
    path: "/analise-relatorios-ia/regras",
    name: "analise-relatorios-ia.regras",
    component: () =>
      import(
        /* webpackChunkName: "analise-relatorios-ia" */ "./components/Regras.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: requireValidationPermission,
  },
];
